/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { molecularModalReducerKey } from '../MolecularModalConstants';
import Cell from './Cell';

function Content({ addValueToQuery }) {
  const { molecularData } = useSelector((state) => state.get(molecularModalReducerKey));
  const fakecell = {
    name: 'actinoids',
    label: 'Actinoids',
    builderValue: '(act)',
  };
  return (
    <div>
      <div className="rx-formula__subheader col-sm-8 clearfix">
        <div className="col-sm-4">
          Special groups:
          <div className="rx-periodic-table rx-periodic-table--special">
            <div className="rx-periodic-table-row">
              {molecularData.specialGroupItems.map((cell, index) => (
                <Cell className="rx-periodic-table-cell" key={`periodic-cell-${index}`} cell={cell} addValueToQuery={addValueToQuery} />
              ))}
            </div>
          </div>
        </div>
      </div>
      {molecularData.metaColumnsItems && (
        <div className="rx-formula__periodic-table rx-periodic-table">
          <header className="rx-periodic-table-header">
            {molecularData.metaColumnsItems.map((cell, index) => (
              <Cell
                className={classnames('rx-periodic-table-cell', { 'rx-periodic-table-cell-narrow': index === 12 })}
                key={`header-cell-${index}`}
                cell={cell}
                addValueToQuery={addValueToQuery}
              />
            ))}
          </header>
          <aside className="rx-periodic-table-aside">
            {molecularData.metaRowsItems &&
              molecularData.metaRowsItems.map((cell, index) => (
                <Cell
                  className={classnames('rx-periodic-table-cell', { 'rx-periodic-table-cell-narrow': index === 12 })}
                  key={`aside-cell-${index}`}
                  cell={cell}
                  addValueToQuery={addValueToQuery}
                />
              ))}
          </aside>
          <section className="rx-periodic-table-content">
            <div className="rx-periodic-table-rows clearfix">
              {molecularData.elementsItems &&
                molecularData.elementsItems.map((row, rowIndex) => (
                  <div className="rx-periodic-table-row" key={`section-row-${rowIndex}`}>
                    {row &&
                      row.map((cell, cellIndex) => (
                        <Cell
                          className={classnames('rx-periodic-table-cell', { 'rx-periodic-table-cell-narrow': cellIndex === 12 })}
                          key={`section-cell-${cellIndex}`}
                          cell={cell}
                          addValueToQuery={addValueToQuery}
                        />
                      ))}
                  </div>
                ))}
            </div>
            <div className="rx-periodic-categories">
              {molecularData.metalicGroupItems &&
                molecularData.metalicGroupItems.map((category, groupItemIndex) => (
                  <div className="rx-periodic-category" key={`group-item-${groupItemIndex}`}>
                    <div className={`rx-periodic-category${(category.groupLabel === 'Metalloids' && '-empty') || ''}-header`}>
                      {category.groupLabel}
                    </div>
                    <div className="rx-periodic-subcategories">
                      {category.groups &&
                        category.groups.map((cell, cellIndex) =>
                          cell && cell.name !== 'actinoids' ? (
                            <div
                              key={`rx-periodic-subcategory-column-${cellIndex}`}
                              className={`rx-periodic-subcategory-column ${
                                cell && cell.name === 'lanthanoids' ? 'rx-periodic-subcategory-fblock' : ''
                              }`}>
                              <div
                                className={`rx-periodic-subcategory rx-periodic-element-${(cell && cell.name) || ''}`}
                                role="button"
                                tabIndex="0"
                                onClick={() => addValueToQuery(cell)}>
                                <div className="rx-periodic-subcategory-label">{(cell && cell.label) || ''}</div>
                              </div>
                              {cell && cell.name === 'lanthanoids' && (
                                <div
                                  className={`rx-periodic-subcategory rx-periodic-element-${(fakecell && fakecell.name) || ''}`}
                                  role="button"
                                  tabIndex="0"
                                  onClick={() => addValueToQuery(cell)}>
                                  <div className="rx-periodic-subcategory-label">{(fakecell && fakecell.label) || ''}</div>
                                </div>
                              )}
                            </div>
                          ) : null
                        )}
                    </div>
                  </div>
                ))}
            </div>
          </section>
        </div>
      )}
    </div>
  );
}

Content.defaultProps = {
  addValueToQuery: () => {},
};
Content.propTypes = {
  addValueToQuery: PropTypes.func,
};

export default Content;
